import { UserProfileWindow } from "src/App/AppLayouts/Shared/Profile/UserProfileWindow";
import { MobilePageBase } from "../Shared/MobilePageBase/MobilePage";

export function ProfilePage() {
    return <MobilePageBase><UserProfileWindow/></MobilePageBase>;
}